

document.title = "Coinhub - Real-Time Cryptocurrency Price Tracker HTML5 Template";

// Create a new link element
const newFavicon = document.createElement("link");

// Set the rel attribute to "icon"
newFavicon.rel = "icon";

// Set the href attribute to the path of your new favicon
newFavicon.href = "./assets/img/Favicon.png";

// Find the existing favicon link element (if any) and remove it
const existingFavicon = document.querySelector("link[rel='icon']");
if (existingFavicon) {
    document.head.removeChild(existingFavicon);
}

// Append the new favicon link element to the head of the document
document.head.appendChild(newFavicon);




document.addEventListener("DOMContentLoaded", function() {
    const loader = document.querySelector(".loader");
    const loaderTop = document.querySelector(".loader-top");
    const loaderBottom = document.querySelector(".loader-bottom");
    const loaderBar = document.querySelector(".loader-bar");
    const loaderNumbering = document.querySelector(".loader-numbering");
    let loadingProgress = 0;
    let isContentLoaded = false;
    let shouldUpdateWidth = true;

    function incrementLoader() {
        if (!shouldUpdateWidth) return;

        loadingProgress += 1;
        const progressPercentage = Math.min(loadingProgress, 100);
        loaderBar.style.width = `${progressPercentage}%`;
        loaderNumbering.textContent = `${progressPercentage}%`;

        if (loadingProgress >= 100 && isContentLoaded) {
            hideLoaderBarAndNumbering();
        }
    }

    function hideLoaderBarAndNumbering() {
        shouldUpdateWidth = false; // Stop updating width
        loaderBar.style.transition = "opacity 0.5s ease-out";
        loaderNumbering.style.transition = "opacity 0.5s ease-out";
        loaderNumbering.style.opacity = "0";
        
        setTimeout(() => {
            loaderBar.style.opacity = "0";
            setTimeout(() => {
                hideLoaderTopAndBottom();
            }, 500);
        }, 500);
    }

    function hideLoaderTopAndBottom() {
        loaderTop.classList.add("hide");
        loaderBottom.classList.add("hide");

        setTimeout(() => {
            loader.classList.add("hide");
            document.body.style.overflow = "auto"; // Enable scrolling
        }, 500);
    }

    // Prevent scrolling when the loader is displayed
    document.body.style.overflow = "hidden";

    // Simulate data loading progress (example)
    const loadingInterval = setInterval(() => {
        incrementLoader();
        if (loadingProgress >= 100) {
            clearInterval(loadingInterval);
            isContentLoaded = true;
        }
    }, 50);

    // Simulate page loading (example)
    window.addEventListener("load", () => {
        isContentLoaded = true;
        if (loadingProgress >= 100) {
            hideLoaderBarAndNumbering();
        }
    });
});



$("header .menu_icon_otr").click(function(){
  $(".overlay_main").addClass("overlay_open");
});
$(".overlay_main .close_icon_otr").click(function(){
  $(".overlay_main").removeClass("overlay_open");
});


/*========== Marquee on hover stop function code ==========*/


$(function() {
    var marquee = $('#text-marquee-effect');
    var marqueePaused = false;
  
    marquee.on('mouseenter', function() {
        marqueePaused = true;
        marquee[0].stop();
    });
  
    marquee.on('mouseleave', function() {
        marqueePaused = false;
        marquee[0].start();
    });
});


$(function() {
    var marquee = $('#text-marquee-effect2');
    var marqueePaused = false;
  
    marquee.on('mouseenter', function() {
        marqueePaused = true;
        marquee[0].stop();
    });
  
    marquee.on('mouseleave', function() {
        marqueePaused = false;
        marquee[0].start();
    });
});

/*========== Marquee on hover stop function code ==========*/


// Function to format market cap
function formatMarketCap(marketCap) {
    const units = ['k', 'M', 'B', 'T'];
    let unitIndex = 0;
    while (marketCap >= 1000 && unitIndex < units.length - 1) {
        marketCap /= 1000;
        unitIndex++;
    }
    return marketCap.toFixed(2) + units[unitIndex];
}

// Array of cryptocurrency symbols and names you want to display
const coinsLists = [
    { container: ".coins-list-1", coins: [
        { symbol: "bitcoin", name: "BTC", rank: 1 },
        { symbol: "ethereum", name: "ETH", rank: 2 },
        { symbol: "tether", name: "USDT", rank: 3 },
        { symbol: "binance-coin", name: "BNB", rank: 4 },
        { symbol: "xrp", name: "XRP", rank: 5 },
        { symbol: "solana", name: "SOL", rank: 6 },
        { symbol: "usd-coin", name: "USDC", rank: 7 },
        { symbol: "cardano", name: "ADA", rank: 8 },
        { symbol: "dogecoin", name: "DOGE", rank: 9 },
        { symbol: "tron", name: "TRX", rank: 10 },
        { symbol: "polygon", name: "MATIC", rank: 11 },
        { symbol: "avalanche", name: "AVAX", rank: 12 },
        { symbol: "chainlink", name: "LINK", rank: 13 },
        { symbol: "polkadot", name: "DOT", rank: 14 },
        { symbol: "wrapped-bitcoin", name: "WBTC", rank: 15 },
        { symbol: "litecoin", name: "LTC", rank: 16 },
        { symbol: "multi-collateral-dai", name: "DAI", rank: 17 },
        { symbol: "shiba-inu", name: "SHIB", rank: 18 },
        { symbol: "bitcoin-cash", name: "BCH", rank: 19 },
        { symbol: "unus-sed-leo", name: "LEO", rank: 20 },
        { symbol: "okb", name: "OKB", rank: 21 },
        { symbol: "stellar", name: "XLM", rank: 22 },
        { symbol: "trueusd", name: "TUSD", rank: 23 },
        { symbol: "uniswap", name: "UNI", rank: 24 },
        { symbol: "monero", name: "XMR", rank: 25 },
        { symbol: "ethereum-classic", name: "ETC", rank: 26 },
        { symbol: "crypto-com-coin", name: "CRO", rank: 27 },
        { symbol: "cosmos", name: "ATOM", rank: 28 },
        { symbol: "filecoin", name: "FIL", rank: 29 },
        { symbol: "thorchain", name: "RUNE", rank: 30 },
        { symbol: "lido-dao", name: "LDO", rank: 31 },
        { symbol: "internet-computer", name: "ICP", rank: 32 },
        { symbol: "bitcoin-bep2", name: "BTCB", rank: 33 },
        { symbol: "binance-usd", name: "BUSD", rank: 34 },
        { symbol: "near-protocol", name: "NEAR", rank: 35 },
        { symbol: "vechain", name: "VET", rank: 36 },
        { symbol: "aave", name: "AAVE", rank: 37 },
        { symbol: "maker", name: "Maker", rank: 38 },
        { symbol: "injective-protocol", name: "INJ", rank: 39 },
        { symbol: "quant", name: "QNT", rank: 40 },
        { symbol: "the-graph", name: "GRT", rank: 41 },
        { symbol: "ftx-token", name: "FTT", rank: 42 },
        { symbol: "algorand", name: "ALGO", rank: 43 },
        { symbol: "elrond-egld", name: "EGLD", rank: 44 },
        { symbol: "render-token", name: "RNDR", rank: 45 },
        { symbol: "fantom", name: "FTM", rank: 46 },
        { symbol: "flow", name: "FLOW", rank: 47 },
        { symbol: "bitcoin-sv", name: "BSV", rank: 48 },
        { symbol: "theta", name: "THETA", rank: 49 },
        { symbol: "stacks", name: "STX", rank: 50 },
        { symbol: "axie-infinity", name: "AXS", rank: 51 },
        { symbol: "hedera-hashgraph", name: "HBAR", rank: 52 },
        { symbol: "the-sandbox", name: "SAND", rank: 53 },
        { symbol: "decentraland", name: "MANA", rank: 54 },
        { symbol: "tezos", name: "XTZ", rank: 55 },
        { symbol: "neo", name: "NEO", rank: 56 },
        { symbol: "eos", name: "EOS", rank: 57 },
        { symbol: "kava", name: "KAVA", rank: 58 },
        { symbol: "synthetix-network-token", name: "SNX", rank: 59 },
        { symbol: "dydx", name: "DYDX", rank: 60 },
        { symbol: "xinfin-network", name: "XDC", rank: 61 },
        { symbol: "gala", name: "GALA", rank: 62 },
        { symbol: "mina", name: "MINA", rank: 63 },
        { symbol: "ecash", name: "XEC", rank: 64 },
        { symbol: "pancakeswap", name: "CAKE", rank: 65 },
        { symbol: "kucoin-token", name: "KCS", rank: 66 },
        { symbol: "chiliz", name: "CHZ", rank: 67 },
        { symbol: "frax-share", name: "FXS", rank: 68 },
        { symbol: "conflux-network", name: "CFX", rank: 69 },
        { symbol: "gas", name: "GAS", rank: 70 },
        { symbol: "iota", name: "IOTA", rank: 71 },
        { symbol: "rocket-pool", name: "RPL", rank: 72 },
        { symbol: "klaytn", name: "KLAY", rank: 73 },
        { symbol: "curve-dao-token", name: "CRV", rank: 74 },
        { symbol: "trust-wallet-token", name: "TWT", rank: 75 },
        { symbol: "zcash", name: "ZEC", rank: 76 },
        { symbol: "arweave", name: "AR", rank: 77 },
        { symbol: "huobi-token", name: "HT", rank: 78 },
        { symbol: "wootrade", name: "WOO", rank: 79 },
        { symbol: "oasis-network", name: "ROSE", rank: 80 },
        { symbol: "gnosis-gno", name: "GNO", rank: 81 },
        { symbol: "yearn-finance", name: "YFI", rank: 82 },
        { symbol: "0x", name: "ZRX", rank: 83 },
        { symbol: "compound", name: "COMP", rank: 84 },
        { symbol: "fei-protocol", name: "FEI", rank: 85 },
        { symbol: "nexo", name: "NEXO", rank: 86 },
        { symbol: "gatetoken", name: "GT", rank: 87 },
        { symbol: "casper", name: "CSPR", rank: 88 },
        { symbol: "1inch", name: "1INCH", rank: 89 },
        { symbol: "zilliqa", name: "ZIL", rank: 90 },
        { symbol: "dash", name: "DASH", rank: 91 },
        { symbol: "fetch", name: "FET", rank: 92 },
        { symbol: "illuvium", name: "ILV", rank: 93 },
        { symbol: "basic-attention-token", name: "BAT", rank: 94 },
        { symbol: "qtum", name: "QTUM", rank: 95 },
        { symbol: "nem", name: "XEM", rank: 96 },
        { symbol: "singularitynet", name: "AGIX", rank: 97 },
        { symbol: "convex-finance", name: "CVX", rank: 98 },
        { symbol: "loopring", name: "LRC", rank: 99 },
        { symbol: "aelf", name: "ELF", rank: 100 },
    ] },
    { container: ".coins-list-2", coins: [
        { symbol: "bitcoin", name: "Bitcoin", rank: 1 },
        { symbol: "ethereum", name: "Ethereum", rank: 2 },
        { symbol: "tether", name: "Tether", rank: 3 },
        { symbol: "binance-coin", name: "BNB", rank: 4 },
        { symbol: "xrp", name: "XRP", rank: 5 },
        { symbol: "usd-coin", name: "USD Coin", rank: 6 },
    ] },
    { container: ".coins-list-3", coins: [
        { symbol: "bitcoin", name: "Bitcoin", rank: 1 },
        { symbol: "ethereum", name: "Ethereum", rank: 2 },
        { symbol: "tether", name: "Tether", rank: 3 },
        { symbol: "binance-coin", name: "BNB", rank: 4 },
        { symbol: "xrp", name: "XRP", rank: 5 },
        { symbol: "usd-coin", name: "USD Coin", rank: 6 },
    ] },
    { container: ".coins-list-4", coins: [
        { symbol: "bitcoin", name: "Bitcoin", rank: 1 },
        { symbol: "tether", name: "Tether", rank: 3 },
        { symbol: "binance-coin", name: "BNB", rank: 4 },
        { symbol: "usd-coin", name: "USD Coin", rank: 6 },
        { symbol: "dogecoin", name: "Dogecoin", rank: 7 },
        { symbol: "cardano", name: "ADA", rank: 8 },
    ] },
    { container: ".coins-list-5", coins: [
        { symbol: "bitcoin", name: "Bitcoin", rank: 1 },
        { symbol: "ethereum", name: "Ethereum", rank: 2 },
        { symbol: "tether", name: "Tether", rank: 3 },
        { symbol: "binance-coin", name: "BNB", rank: 4 },
        { symbol: "xrp", name: "XRP", rank: 5 },
        { symbol: "usd-coin", name: "USD Coin", rank: 6 },
        { symbol: "dogecoin", name: "Dogecoin", rank: 7 },
        { symbol: "cardano", name: "ADA", rank: 8 },
        { symbol: "solana", name: "Solana", rank: 9 },
        { symbol: "tron", name: "TRON", rank: 10 },
        { symbol: "polkadot", name: "Polkadot", rank: 11 },
        { symbol: "polygon", name: "Polygon", rank: 12 },
    ] },
    { container: ".coins-list-6", coins: [
        { symbol: "bitcoin", name: "BTC", rank: 1 },
        { symbol: "ethereum", name: "ETH", rank: 2 },
        { symbol: "tether", name: "USDT", rank: 3 },
        { symbol: "binance-coin", name: "BNB", rank: 4 },
        { symbol: "xrp", name: "XRP", rank: 5 },
        { symbol: "solana", name: "SOL", rank: 6 },
        { symbol: "usd-coin", name: "USDC", rank: 7 },
        { symbol: "cardano", name: "ADA", rank: 8 },
        { symbol: "dogecoin", name: "DOGE", rank: 9 },
        { symbol: "tron", name: "TRX", rank: 10 },
        { symbol: "polygon", name: "MATIC", rank: 11 },
        { symbol: "avalanche", name: "AVAX", rank: 12 },
        { symbol: "chainlink", name: "LINK", rank: 13 },
        { symbol: "polkadot", name: "DOT", rank: 14 },
        { symbol: "wrapped-bitcoin", name: "WBTC", rank: 15 },
        { symbol: "litecoin", name: "LTC", rank: 16 },
        { symbol: "multi-collateral-dai", name: "DAI", rank: 17 },
        { symbol: "shiba-inu", name: "SHIB", rank: 18 },
        { symbol: "bitcoin-cash", name: "BCH", rank: 19 },
        { symbol: "unus-sed-leo", name: "LEO", rank: 20 },
        { symbol: "okb", name: "OKB", rank: 21 },
        { symbol: "stellar", name: "XLM", rank: 22 },
        { symbol: "trueusd", name: "TUSD", rank: 23 },
        { symbol: "uniswap", name: "UNI", rank: 24 },
        { symbol: "monero", name: "XMR", rank: 25 },
        { symbol: "ethereum-classic", name: "ETC", rank: 26 },
        { symbol: "crypto-com-coin", name: "CRO", rank: 27 },
        { symbol: "cosmos", name: "ATOM", rank: 28 },
        { symbol: "filecoin", name: "FIL", rank: 29 },
        { symbol: "thorchain", name: "RUNE", rank: 30 },
        { symbol: "lido-dao", name: "LDO", rank: 31 },
        { symbol: "internet-computer", name: "ICP", rank: 32 },
        { symbol: "bitcoin-bep2", name: "BTCB", rank: 33 },
        { symbol: "binance-usd", name: "BUSD", rank: 34 },
        { symbol: "near-protocol", name: "NEAR", rank: 35 },
        { symbol: "vechain", name: "VET", rank: 36 },
        { symbol: "aave", name: "AAVE", rank: 37 },
        { symbol: "maker", name: "Maker", rank: 38 },
        { symbol: "injective-protocol", name: "INJ", rank: 39 },
        { symbol: "quant", name: "QNT", rank: 40 },
        { symbol: "the-graph", name: "GRT", rank: 41 },
        { symbol: "ftx-token", name: "FTT", rank: 42 },
        { symbol: "algorand", name: "ALGO", rank: 43 },
        { symbol: "elrond-egld", name: "EGLD", rank: 44 },
        { symbol: "render-token", name: "RNDR", rank: 45 },
        { symbol: "fantom", name: "FTM", rank: 46 },
        { symbol: "flow", name: "FLOW", rank: 47 },
        { symbol: "bitcoin-sv", name: "BSV", rank: 48 },
        { symbol: "theta", name: "THETA", rank: 49 },
        { symbol: "stacks", name: "STX", rank: 50 },
        { symbol: "axie-infinity", name: "AXS", rank: 51 },
        { symbol: "hedera-hashgraph", name: "HBAR", rank: 52 },
        { symbol: "the-sandbox", name: "SAND", rank: 53 },
        { symbol: "decentraland", name: "MANA", rank: 54 },
        { symbol: "tezos", name: "XTZ", rank: 55 },
        { symbol: "neo", name: "NEO", rank: 56 },
        { symbol: "eos", name: "EOS", rank: 57 },
        { symbol: "kava", name: "KAVA", rank: 58 },
        { symbol: "synthetix-network-token", name: "SNX", rank: 59 },
        { symbol: "dydx", name: "DYDX", rank: 60 },
        { symbol: "xinfin-network", name: "XDC", rank: 61 },
        { symbol: "gala", name: "GALA", rank: 62 },
        { symbol: "mina", name: "MINA", rank: 63 },
        { symbol: "ecash", name: "XEC", rank: 64 },
        { symbol: "pancakeswap", name: "CAKE", rank: 65 },
        { symbol: "kucoin-token", name: "KCS", rank: 66 },
        { symbol: "chiliz", name: "CHZ", rank: 67 },
        { symbol: "frax-share", name: "FXS", rank: 68 },
        { symbol: "conflux-network", name: "CFX", rank: 69 },
        { symbol: "gas", name: "GAS", rank: 70 },
        { symbol: "iota", name: "IOTA", rank: 71 },
        { symbol: "rocket-pool", name: "RPL", rank: 72 },
        { symbol: "klaytn", name: "KLAY", rank: 73 },
        { symbol: "curve-dao-token", name: "CRV", rank: 74 },
        { symbol: "trust-wallet-token", name: "TWT", rank: 75 },
        { symbol: "zcash", name: "ZEC", rank: 76 },
        { symbol: "arweave", name: "AR", rank: 77 },
        { symbol: "huobi-token", name: "HT", rank: 78 },
        { symbol: "wootrade", name: "WOO", rank: 79 },
        { symbol: "oasis-network", name: "ROSE", rank: 80 },
        { symbol: "gnosis-gno", name: "GNO", rank: 81 },
        { symbol: "yearn-finance", name: "YFI", rank: 82 },
        { symbol: "0x", name: "ZRX", rank: 83 },
        { symbol: "compound", name: "COMP", rank: 84 },
        { symbol: "fei-protocol", name: "FEI", rank: 85 },
        { symbol: "nexo", name: "NEXO", rank: 86 },
        { symbol: "gatetoken", name: "GT", rank: 87 },
        { symbol: "casper", name: "CSPR", rank: 88 },
        { symbol: "1inch", name: "1INCH", rank: 89 },
        { symbol: "zilliqa", name: "ZIL", rank: 90 },
        { symbol: "dash", name: "DASH", rank: 91 },
        { symbol: "fetch", name: "FET", rank: 92 },
        { symbol: "illuvium", name: "ILV", rank: 93 },
        { symbol: "basic-attention-token", name: "BAT", rank: 94 },
        { symbol: "qtum", name: "QTUM", rank: 95 },
        { symbol: "nem", name: "XEM", rank: 96 },
        { symbol: "singularitynet", name: "AGIX", rank: 97 },
        { symbol: "convex-finance", name: "CVX", rank: 98 },
        { symbol: "loopring", name: "LRC", rank: 99 },
        { symbol: "aelf", name: "ELF", rank: 100 },
    ] },
    { container: ".coins-list-7", coins: [
        { symbol: "bitcoin", name: "BTC", rank: 1 },
        { symbol: "ethereum", name: "ETH", rank: 2 },
        { symbol: "tether", name: "USDT", rank: 3 },
        { symbol: "binance-coin", name: "BNB", rank: 4 },
        { symbol: "xrp", name: "XRP", rank: 5 },
        { symbol: "solana", name: "SOL", rank: 6 },
        { symbol: "usd-coin", name: "USDC", rank: 7 },
        { symbol: "cardano", name: "ADA", rank: 8 },
        { symbol: "dogecoin", name: "DOGE", rank: 9 },
        { symbol: "tron", name: "TRX", rank: 10 },
        { symbol: "polygon", name: "MATIC", rank: 11 },
        { symbol: "avalanche", name: "AVAX", rank: 12 },
        { symbol: "chainlink", name: "LINK", rank: 13 },
        { symbol: "polkadot", name: "DOT", rank: 14 },
        { symbol: "wrapped-bitcoin", name: "WBTC", rank: 15 },
        { symbol: "litecoin", name: "LTC", rank: 16 },
        { symbol: "multi-collateral-dai", name: "DAI", rank: 17 },
        { symbol: "shiba-inu", name: "SHIB", rank: 18 },
        { symbol: "bitcoin-cash", name: "BCH", rank: 19 },
        { symbol: "unus-sed-leo", name: "LEO", rank: 20 },
        { symbol: "okb", name: "OKB", rank: 21 },
        { symbol: "stellar", name: "XLM", rank: 22 },
        { symbol: "trueusd", name: "TUSD", rank: 23 },
        { symbol: "uniswap", name: "UNI", rank: 24 },
        { symbol: "monero", name: "XMR", rank: 25 },
        { symbol: "ethereum-classic", name: "ETC", rank: 26 },
        { symbol: "crypto-com-coin", name: "CRO", rank: 27 },
        { symbol: "cosmos", name: "ATOM", rank: 28 },
        { symbol: "filecoin", name: "FIL", rank: 29 },
        { symbol: "thorchain", name: "RUNE", rank: 30 },
        { symbol: "lido-dao", name: "LDO", rank: 31 },
        { symbol: "internet-computer", name: "ICP", rank: 32 },
        { symbol: "bitcoin-bep2", name: "BTCB", rank: 33 },
        { symbol: "binance-usd", name: "BUSD", rank: 34 },
        { symbol: "near-protocol", name: "NEAR", rank: 35 },
        { symbol: "vechain", name: "VET", rank: 36 },
        { symbol: "aave", name: "AAVE", rank: 37 },
        { symbol: "maker", name: "Maker", rank: 38 },
        { symbol: "injective-protocol", name: "INJ", rank: 39 },
        { symbol: "quant", name: "QNT", rank: 40 },
        { symbol: "the-graph", name: "GRT", rank: 41 },
        { symbol: "ftx-token", name: "FTT", rank: 42 },
        { symbol: "algorand", name: "ALGO", rank: 43 },
        { symbol: "elrond-egld", name: "EGLD", rank: 44 },
        { symbol: "render-token", name: "RNDR", rank: 45 },
        { symbol: "fantom", name: "FTM", rank: 46 },
        { symbol: "flow", name: "FLOW", rank: 47 },
        { symbol: "bitcoin-sv", name: "BSV", rank: 48 },
        { symbol: "theta", name: "THETA", rank: 49 },
        { symbol: "stacks", name: "STX", rank: 50 },
        { symbol: "axie-infinity", name: "AXS", rank: 51 },
        { symbol: "hedera-hashgraph", name: "HBAR", rank: 52 },
        { symbol: "the-sandbox", name: "SAND", rank: 53 },
        { symbol: "decentraland", name: "MANA", rank: 54 },
        { symbol: "tezos", name: "XTZ", rank: 55 },
        { symbol: "neo", name: "NEO", rank: 56 },
        { symbol: "eos", name: "EOS", rank: 57 },
        { symbol: "kava", name: "KAVA", rank: 58 },
        { symbol: "synthetix-network-token", name: "SNX", rank: 59 },
        { symbol: "dydx", name: "DYDX", rank: 60 },
        { symbol: "xinfin-network", name: "XDC", rank: 61 },
        { symbol: "gala", name: "GALA", rank: 62 },
        { symbol: "mina", name: "MINA", rank: 63 },
        { symbol: "ecash", name: "XEC", rank: 64 },
        { symbol: "pancakeswap", name: "CAKE", rank: 65 },
        { symbol: "kucoin-token", name: "KCS", rank: 66 },
        { symbol: "chiliz", name: "CHZ", rank: 67 },
        { symbol: "frax-share", name: "FXS", rank: 68 },
        { symbol: "conflux-network", name: "CFX", rank: 69 },
        { symbol: "gas", name: "GAS", rank: 70 },
        { symbol: "iota", name: "IOTA", rank: 71 },
        { symbol: "rocket-pool", name: "RPL", rank: 72 },
        { symbol: "klaytn", name: "KLAY", rank: 73 },
        { symbol: "curve-dao-token", name: "CRV", rank: 74 },
        { symbol: "trust-wallet-token", name: "TWT", rank: 75 },
        { symbol: "zcash", name: "ZEC", rank: 76 },
        { symbol: "arweave", name: "AR", rank: 77 },
        { symbol: "huobi-token", name: "HT", rank: 78 },
        { symbol: "wootrade", name: "WOO", rank: 79 },
        { symbol: "oasis-network", name: "ROSE", rank: 80 },
        { symbol: "gnosis-gno", name: "GNO", rank: 81 },
        { symbol: "yearn-finance", name: "YFI", rank: 82 },
        { symbol: "0x", name: "ZRX", rank: 83 },
        { symbol: "compound", name: "COMP", rank: 84 },
        { symbol: "fei-protocol", name: "FEI", rank: 85 },
        { symbol: "nexo", name: "NEXO", rank: 86 },
        { symbol: "gatetoken", name: "GT", rank: 87 },
        { symbol: "casper", name: "CSPR", rank: 88 },
        { symbol: "1inch", name: "1INCH", rank: 89 },
        { symbol: "zilliqa", name: "ZIL", rank: 90 },
        { symbol: "dash", name: "DASH", rank: 91 },
        { symbol: "fetch", name: "FET", rank: 92 },
        { symbol: "illuvium", name: "ILV", rank: 93 },
        { symbol: "basic-attention-token", name: "BAT", rank: 94 },
        { symbol: "qtum", name: "QTUM", rank: 95 },
        { symbol: "nem", name: "XEM", rank: 96 },
        { symbol: "singularitynet", name: "AGIX", rank: 97 },
        { symbol: "convex-finance", name: "CVX", rank: 98 },
        { symbol: "loopring", name: "LRC", rank: 99 },
        { symbol: "aelf", name: "ELF", rank: 100 },
    ] },
    { container: ".coins-list-8", coins: [
        { symbol: "bitcoin", name: "BTC", rank: 1 },
        { symbol: "ethereum", name: "ETH", rank: 2 },
        { symbol: "tether", name: "USDT", rank: 3 },
        { symbol: "binance-coin", name: "BNB", rank: 4 },
        { symbol: "xrp", name: "XRP", rank: 5 },
        { symbol: "solana", name: "SOL", rank: 6 },
        { symbol: "usd-coin", name: "USDC", rank: 7 },
        { symbol: "cardano", name: "ADA", rank: 8 },
        { symbol: "dogecoin", name: "DOGE", rank: 9 },
        { symbol: "tron", name: "TRX", rank: 10 },
        { symbol: "polygon", name: "MATIC", rank: 11 },
        { symbol: "avalanche", name: "AVAX", rank: 12 },
        { symbol: "chainlink", name: "LINK", rank: 13 },
        { symbol: "polkadot", name: "DOT", rank: 14 },
        { symbol: "wrapped-bitcoin", name: "WBTC", rank: 15 },
        { symbol: "litecoin", name: "LTC", rank: 16 },
        { symbol: "multi-collateral-dai", name: "DAI", rank: 17 },
        { symbol: "shiba-inu", name: "SHIB", rank: 18 },
        { symbol: "bitcoin-cash", name: "BCH", rank: 19 },
        { symbol: "unus-sed-leo", name: "LEO", rank: 20 },
        { symbol: "okb", name: "OKB", rank: 21 },
        { symbol: "stellar", name: "XLM", rank: 22 },
        { symbol: "trueusd", name: "TUSD", rank: 23 },
        { symbol: "uniswap", name: "UNI", rank: 24 },
        { symbol: "monero", name: "XMR", rank: 25 },
        { symbol: "ethereum-classic", name: "ETC", rank: 26 },
        { symbol: "crypto-com-coin", name: "CRO", rank: 27 },
        { symbol: "cosmos", name: "ATOM", rank: 28 },
        { symbol: "filecoin", name: "FIL", rank: 29 },
        { symbol: "thorchain", name: "RUNE", rank: 30 },
        { symbol: "lido-dao", name: "LDO", rank: 31 },
        { symbol: "internet-computer", name: "ICP", rank: 32 },
        { symbol: "bitcoin-bep2", name: "BTCB", rank: 33 },
        { symbol: "binance-usd", name: "BUSD", rank: 34 },
        { symbol: "near-protocol", name: "NEAR", rank: 35 },
        { symbol: "vechain", name: "VET", rank: 36 },
        { symbol: "aave", name: "AAVE", rank: 37 },
        { symbol: "maker", name: "Maker", rank: 38 },
        { symbol: "injective-protocol", name: "INJ", rank: 39 },
        { symbol: "quant", name: "QNT", rank: 40 },
        { symbol: "the-graph", name: "GRT", rank: 41 },
        { symbol: "ftx-token", name: "FTT", rank: 42 },
        { symbol: "algorand", name: "ALGO", rank: 43 },
        { symbol: "elrond-egld", name: "EGLD", rank: 44 },
        { symbol: "render-token", name: "RNDR", rank: 45 },
        { symbol: "fantom", name: "FTM", rank: 46 },
        { symbol: "flow", name: "FLOW", rank: 47 },
        { symbol: "bitcoin-sv", name: "BSV", rank: 48 },
        { symbol: "theta", name: "THETA", rank: 49 },
        { symbol: "stacks", name: "STX", rank: 50 },
        { symbol: "axie-infinity", name: "AXS", rank: 51 },
        { symbol: "hedera-hashgraph", name: "HBAR", rank: 52 },
        { symbol: "the-sandbox", name: "SAND", rank: 53 },
        { symbol: "decentraland", name: "MANA", rank: 54 },
        { symbol: "tezos", name: "XTZ", rank: 55 },
        { symbol: "neo", name: "NEO", rank: 56 },
        { symbol: "eos", name: "EOS", rank: 57 },
        { symbol: "kava", name: "KAVA", rank: 58 },
        { symbol: "synthetix-network-token", name: "SNX", rank: 59 },
        { symbol: "dydx", name: "DYDX", rank: 60 },
        { symbol: "xinfin-network", name: "XDC", rank: 61 },
        { symbol: "gala", name: "GALA", rank: 62 },
        { symbol: "mina", name: "MINA", rank: 63 },
        { symbol: "ecash", name: "XEC", rank: 64 },
        { symbol: "pancakeswap", name: "CAKE", rank: 65 },
        { symbol: "kucoin-token", name: "KCS", rank: 66 },
        { symbol: "chiliz", name: "CHZ", rank: 67 },
        { symbol: "frax-share", name: "FXS", rank: 68 },
        { symbol: "conflux-network", name: "CFX", rank: 69 },
        { symbol: "gas", name: "GAS", rank: 70 },
        { symbol: "iota", name: "IOTA", rank: 71 },
        { symbol: "rocket-pool", name: "RPL", rank: 72 },
        { symbol: "klaytn", name: "KLAY", rank: 73 },
        { symbol: "curve-dao-token", name: "CRV", rank: 74 },
        { symbol: "trust-wallet-token", name: "TWT", rank: 75 },
        { symbol: "zcash", name: "ZEC", rank: 76 },
        { symbol: "arweave", name: "AR", rank: 77 },
        { symbol: "huobi-token", name: "HT", rank: 78 },
        { symbol: "wootrade", name: "WOO", rank: 79 },
        { symbol: "oasis-network", name: "ROSE", rank: 80 },
        { symbol: "gnosis-gno", name: "GNO", rank: 81 },
        { symbol: "yearn-finance", name: "YFI", rank: 82 },
        { symbol: "0x", name: "ZRX", rank: 83 },
        { symbol: "compound", name: "COMP", rank: 84 },
        { symbol: "fei-protocol", name: "FEI", rank: 85 },
        { symbol: "nexo", name: "NEXO", rank: 86 },
        { symbol: "gatetoken", name: "GT", rank: 87 },
        { symbol: "casper", name: "CSPR", rank: 88 },
        { symbol: "1inch", name: "1INCH", rank: 89 },
        { symbol: "zilliqa", name: "ZIL", rank: 90 },
        { symbol: "dash", name: "DASH", rank: 91 },
        { symbol: "fetch", name: "FET", rank: 92 },
        { symbol: "illuvium", name: "ILV", rank: 93 },
        { symbol: "basic-attention-token", name: "BAT", rank: 94 },
        { symbol: "qtum", name: "QTUM", rank: 95 },
        { symbol: "nem", name: "XEM", rank: 96 },
        { symbol: "singularitynet", name: "AGIX", rank: 97 },
        { symbol: "convex-finance", name: "CVX", rank: 98 },
        { symbol: "loopring", name: "LRC", rank: 99 },
        { symbol: "aelf", name: "ELF", rank: 100 },
    ] },
    { container: ".coins-list-9", coins: [
        { symbol: "bitcoin", name: "Bitcoin", rank: 1 },
        { symbol: "ethereum", name: "Ethereum", rank: 2 },
        { symbol: "tether", name: "Tether", rank: 3 },
        { symbol: "binance-coin", name: "BNB", rank: 4 },
        { symbol: "xrp", name: "XRP", rank: 5 },
        { symbol: "usd-coin", name: "USD Coin", rank: 6 },
        { symbol: "dogecoin", name: "Dogecoin", rank: 7 },
        { symbol: "cardano", name: "ADA", rank: 8 },
        { symbol: "solana", name: "Solana", rank: 9 },
        { symbol: "tron", name: "TRON", rank: 10 },
        { symbol: "polkadot", name: "Polkadot", rank: 11 },
        { symbol: "polygon", name: "Polygon", rank: 12 },
    ] },
    { container: ".coins-list-10", coins: [
        { symbol: "bitcoin", name: "Bitcoin", rank: 1 },
        { symbol: "ethereum", name: "Ethereum", rank: 2 },
        { symbol: "tether", name: "Tether", rank: 3 },
        { symbol: "binance-coin", name: "BNB", rank: 4 },
        { symbol: "xrp", name: "XRP", rank: 5 },
        { symbol: "usd-coin", name: "USD Coin", rank: 6 },
        { symbol: "dogecoin", name: "Dogecoin", rank: 7 },
        { symbol: "cardano", name: "ADA", rank: 8 },
        { symbol: "solana", name: "Solana", rank: 9 },
        { symbol: "tron", name: "TRON", rank: 10 },
        { symbol: "polkadot", name: "Polkadot", rank: 11 },
        { symbol: "polygon", name: "Polygon", rank: 12 },
    ]
    },
    { container: ".coins-list-11", coins: [
        { symbol: "bitcoin", name: "BTC", rank: 1 },
        { symbol: "ethereum", name: "ETH", rank: 2 },
        { symbol: "tether", name: "USDT", rank: 3 },
        { symbol: "binance-coin", name: "BNB", rank: 4 },
        { symbol: "xrp", name: "XRP", rank: 5 },
        { symbol: "solana", name: "SOL", rank: 6 },
        { symbol: "usd-coin", name: "USDC", rank: 7 },
        { symbol: "cardano", name: "ADA", rank: 8 },
        { symbol: "dogecoin", name: "DOGE", rank: 9 },
        { symbol: "tron", name: "TRX", rank: 10 },
        { symbol: "polygon", name: "MATIC", rank: 11 },
        { symbol: "avalanche", name: "AVAX", rank: 12 },
        { symbol: "chainlink", name: "LINK", rank: 13 },
        { symbol: "polkadot", name: "DOT", rank: 14 },
        { symbol: "wrapped-bitcoin", name: "WBTC", rank: 15 },
        { symbol: "litecoin", name: "LTC", rank: 16 },
        { symbol: "multi-collateral-dai", name: "DAI", rank: 17 },
        { symbol: "shiba-inu", name: "SHIB", rank: 18 },
        { symbol: "bitcoin-cash", name: "BCH", rank: 19 },
        { symbol: "unus-sed-leo", name: "LEO", rank: 20 },
        { symbol: "okb", name: "OKB", rank: 21 },
        { symbol: "stellar", name: "XLM", rank: 22 },
        { symbol: "trueusd", name: "TUSD", rank: 23 },
        { symbol: "uniswap", name: "UNI", rank: 24 },
        { symbol: "monero", name: "XMR", rank: 25 },
        { symbol: "ethereum-classic", name: "ETC", rank: 26 },
        { symbol: "crypto-com-coin", name: "CRO", rank: 27 },
        { symbol: "cosmos", name: "ATOM", rank: 28 },
        { symbol: "filecoin", name: "FIL", rank: 29 },
        { symbol: "thorchain", name: "RUNE", rank: 30 },
        { symbol: "lido-dao", name: "LDO", rank: 31 },
        { symbol: "internet-computer", name: "ICP", rank: 32 },
        { symbol: "bitcoin-bep2", name: "BTCB", rank: 33 },
        { symbol: "binance-usd", name: "BUSD", rank: 34 },
        { symbol: "near-protocol", name: "NEAR", rank: 35 },
        { symbol: "vechain", name: "VET", rank: 36 },
        { symbol: "aave", name: "AAVE", rank: 37 },
        { symbol: "maker", name: "Maker", rank: 38 },
        { symbol: "injective-protocol", name: "INJ", rank: 39 },
        { symbol: "quant", name: "QNT", rank: 40 },
        { symbol: "the-graph", name: "GRT", rank: 41 },
        { symbol: "ftx-token", name: "FTT", rank: 42 },
        { symbol: "algorand", name: "ALGO", rank: 43 },
        { symbol: "elrond-egld", name: "EGLD", rank: 44 },
        { symbol: "render-token", name: "RNDR", rank: 45 },
        { symbol: "fantom", name: "FTM", rank: 46 },
        { symbol: "flow", name: "FLOW", rank: 47 },
        { symbol: "bitcoin-sv", name: "BSV", rank: 48 },
        { symbol: "theta", name: "THETA", rank: 49 },
        { symbol: "stacks", name: "STX", rank: 50 },
        { symbol: "axie-infinity", name: "AXS", rank: 51 },
        { symbol: "hedera-hashgraph", name: "HBAR", rank: 52 },
        { symbol: "the-sandbox", name: "SAND", rank: 53 },
        { symbol: "decentraland", name: "MANA", rank: 54 },
        { symbol: "tezos", name: "XTZ", rank: 55 },
        { symbol: "neo", name: "NEO", rank: 56 },
        { symbol: "eos", name: "EOS", rank: 57 },
        { symbol: "kava", name: "KAVA", rank: 58 },
        { symbol: "synthetix-network-token", name: "SNX", rank: 59 },
        { symbol: "dydx", name: "DYDX", rank: 60 },
        { symbol: "xinfin-network", name: "XDC", rank: 61 },
        { symbol: "gala", name: "GALA", rank: 62 },
        { symbol: "mina", name: "MINA", rank: 63 },
        { symbol: "ecash", name: "XEC", rank: 64 },
        { symbol: "pancakeswap", name: "CAKE", rank: 65 },
        { symbol: "kucoin-token", name: "KCS", rank: 66 },
        { symbol: "chiliz", name: "CHZ", rank: 67 },
        { symbol: "frax-share", name: "FXS", rank: 68 },
        { symbol: "conflux-network", name: "CFX", rank: 69 },
        { symbol: "gas", name: "GAS", rank: 70 },
        { symbol: "iota", name: "IOTA", rank: 71 },
        { symbol: "rocket-pool", name: "RPL", rank: 72 },
        { symbol: "klaytn", name: "KLAY", rank: 73 },
        { symbol: "curve-dao-token", name: "CRV", rank: 74 },
        { symbol: "trust-wallet-token", name: "TWT", rank: 75 },
        { symbol: "zcash", name: "ZEC", rank: 76 },
        { symbol: "arweave", name: "AR", rank: 77 },
        { symbol: "huobi-token", name: "HT", rank: 78 },
        { symbol: "wootrade", name: "WOO", rank: 79 },
        { symbol: "oasis-network", name: "ROSE", rank: 80 },
        { symbol: "gnosis-gno", name: "GNO", rank: 81 },
        { symbol: "yearn-finance", name: "YFI", rank: 82 },
        { symbol: "0x", name: "ZRX", rank: 83 },
        { symbol: "compound", name: "COMP", rank: 84 },
        { symbol: "fei-protocol", name: "FEI", rank: 85 },
        { symbol: "nexo", name: "NEXO", rank: 86 },
        { symbol: "gatetoken", name: "GT", rank: 87 },
        { symbol: "casper", name: "CSPR", rank: 88 },
        { symbol: "1inch", name: "1INCH", rank: 89 },
        { symbol: "zilliqa", name: "ZIL", rank: 90 },
        { symbol: "dash", name: "DASH", rank: 91 },
        { symbol: "fetch", name: "FET", rank: 92 },
        { symbol: "illuvium", name: "ILV", rank: 93 },
        { symbol: "basic-attention-token", name: "BAT", rank: 94 },
        { symbol: "qtum", name: "QTUM", rank: 95 },
        { symbol: "nem", name: "XEM", rank: 96 },
        { symbol: "singularitynet", name: "AGIX", rank: 97 },
        { symbol: "convex-finance", name: "CVX", rank: 98 },
        { symbol: "loopring", name: "LRC", rank: 99 },
        { symbol: "aelf", name: "ELF", rank: 100 },
    ] },
    // Add more lists with their coins as needed
];

coinsLists.forEach((coinsList, index) => {
    coinsList.coins.forEach((coin, coinIndex) => {
        getCoinData(coin.symbol, coinsList.container, index, coinIndex);
    });
});

function getCoinData(coinSymbol, container, index, coinIndex) {
    fetch(`https://api.coincap.io/v2/assets/${coinSymbol}`)
        .then(response => response.json())
        .then(data => {
            const coinInfo = data.data;
            getCoinPriceHistory(coinSymbol, coinInfo, container, index, coinIndex);
        })
        .catch(error => {
            console.error("Failed to fetch coin data.", error);
        });
}

function getCoinPriceHistory(coinSymbol, coinInfo, container, index, coinIndex) {
    fetch(`https://api.coincap.io/v2/assets/${coinSymbol}/history?interval=d1`)
        .then(response => response.json())
        .then(data => {
            const priceData = data.data;
            displayCoinData(coinInfo, priceData, container, index, coinIndex);
        })
        .catch(error => {
            console.error("Failed to fetch price history data.", error);
        });
}

function displayCoinData(coinInfo, priceData, container, index, coinIndex) {
    const coinsList = document.querySelector(container);

    const coinCard = document.createElement("div");
    coinCard.classList.add("col-lg-4");

    const formattedCurrentPrice = parseFloat(coinInfo.priceUsd).toFixed(2);

    const changePercent = parseFloat(coinInfo.changePercent24Hr);
    const formattedPriceChange = isNaN(changePercent)
    ? "N/A" // Handle invalid or missing data
    : changePercent >= 0
        ? `+${changePercent.toFixed(2)}%`
        : `-${Math.abs(changePercent).toFixed(2)}%`;

    const iconName = coinInfo.name.charAt(0).toLowerCase() + coinInfo.name.slice(1);
    const imagePath = `https://vistothemes.com/cryptocurrency/coins/${iconName}.png`;

    // Customize display based on coin list
    if (index === 0) {
        // Coin List 1: Display Everything
        coinCard.innerHTML = `
            <div class="marquee">
                <div class="coin-img-otr">
                    <img class="coin-img" class="${coinInfo.name}" src="${imagePath}" alt="${coinInfo.name}" />
                </div>
                <p class="coin-name">${coinInfo.name}</p>
                <p class="current-price">$${formattedCurrentPrice}</p>
                <p class="price-change ${changePercent >= 0 ? 'positive-change' : 'negative-change'}">${formattedPriceChange}</p>
            </div>
        `;

        coinsList.appendChild(coinCard);

    }  else if (index === 1) {
        // Coin List 2: Display Everything Except Market Cap and Price Chart
        coinCard.innerHTML = `
            <div class="col-inr">
                <div class="card-head">
                    <div class="coin-basic-info">
                        <div class="coin-img-otr">
                            <img class="coin-img" src="${imagePath}" alt="${coinInfo.name}" />
                        </div>
                        <div class="coin-name-info">
                            <p class="coin-name">${coinInfo.name}</p>
                            <p class="coin-symbol">${coinInfo.symbol}</p>
                        </div>
                    </div>
                </div>
                <div class="current-price-otr">
                    <div class="current-price-inr">
                        <p class="current-price">$${formattedCurrentPrice}</p>
                        <p class="market-cap">Market Cap : $${formatMarketCap(parseFloat(coinInfo.marketCapUsd))}</p>
                    </div>
                    <div class="price-change-otr">
                        <p class="price-change ${changePercent >= 0 ? 'positive-change' : 'negative-change'}">${formattedPriceChange}</p>
                    </div>
                </div>
                <div class="price-chart">
                    <canvas id="${coinInfo.id}-chart-${container}-${index}-${coinIndex}"></canvas>
                </div>
            </div>
        `;

        coinsList.appendChild(coinCard);

    } else if (index === 2) {
        // Coin List 3: Display Everything
        coinCard.innerHTML = `
            <div class="col-inr">
                <div class="coin-basic-info">
                    <div class="coin-img-otr">
                        <img class="coin-img" class="${coinInfo.name}" src="${imagePath}" alt="${coinInfo.name}" />
                        <p class="coin-name">${coinInfo.name}</p>
                    </div>
                    <div class="coin-name-info">
                        <p class="coin-symbol">${coinInfo.symbol}</p>
                    </div>
                </div>
                <div class="coin-name-info">
                    <p class="current-price"> $${formattedCurrentPrice} </p>
                </div>
                <div class="price-chart">
                    <canvas id="${coinInfo.id}-chart-${container}-${index}-${coinIndex}"></canvas>
                </div>
                <div class="price-change-otr">
                    <p class="price-change ${changePercent >= 0 ? 'positive-change' : 'negative-change'}">${formattedPriceChange}</p>
                    <p class="market-cap">Market Cap : $${formatMarketCap(parseFloat(coinInfo.marketCapUsd))}</p>
                </div>
            </div>
        `;

        coinsList.appendChild(coinCard);

    } else if (index === 3) {
        // Coin List 4: Display Everything
        coinCard.innerHTML = `
            <div class="marquee">
                <div class="flex-main">
                    <div class="coin-img-otr">
                        <img class="coin-img" class="${coinInfo.name}" src="${imagePath}" alt="${coinInfo.name}" />
                    </div>
                    <div class="coin-prices-main">
                        <p class="coin-name">${coinInfo.name} <span>(${coinInfo.symbol})</span></p>
                        <p class="current-price">$${formattedCurrentPrice}</p>
                    </div>
                </div>
                <p class="price-change ${changePercent >= 0 ? 'positive-change' : 'negative-change'}">${formattedPriceChange}</p>
            </div>
        `;

        coinsList.appendChild(coinCard);

    } else if (index === 4) {
        // Coin List 5: Display Everything
        coinCard.innerHTML = `
            <div class="col-inr">
                <div class="coin-basic-info">
                    <div class="coin-img-otr">
                        <img class="coin-img" class="${coinInfo.name}" src="${imagePath}" alt="${coinInfo.name}" />
                        <p class="coin-name">${coinInfo.name}</p>
                    </div>
                    <div class="coin-name-info">
                        <p class="coin-symbol">${coinInfo.symbol}</p>
                    </div>
                </div>
                <div class="coin-name-info">
                <p class="current-price"> $${formattedCurrentPrice} </p>
                </div>
                <div class="price-chart">
                    <canvas id="${coinInfo.id}-chart-${container}-${index}-${coinIndex}"></canvas>
                </div>
                <div class="price-change-otr">
                    <p class="price-change ${changePercent >= 0 ? 'positive-change' : 'negative-change'}">${formattedPriceChange}</p>
                    <p class="market-cap">Market Cap : $${formatMarketCap(parseFloat(coinInfo.marketCapUsd))}</p>
                </div>
            </div>
        `;

        coinsList.appendChild(coinCard);

    } else if (index === 5) {
        // Coin List 6: Display Everything
        coinCard.innerHTML = `
            <div class="marquee">
                <div class="coin-img-otr">
                    <img class="coin-img" class="${coinInfo.name}" src="${imagePath}" alt="${coinInfo.name}" />
                </div>
                <p class="coin-name">${coinInfo.name}</p>
                <p class="current-price">$${formattedCurrentPrice}</p>
                <p class="price-change ${changePercent >= 0 ? 'positive-change' : 'negative-change'}">${formattedPriceChange}</p>
            </div>
        `;

        coinsList.appendChild(coinCard);

    } else if (index === 6) {
        // Coin List 7: Display Everything
        coinCard.innerHTML = `
            <div class="marquee">
                <div class="coin-img-otr">
                    <img class="coin-img" class="${coinInfo.name}" src="${imagePath}" alt="${coinInfo.name}" />
                </div>
                <p class="coin-name">${coinInfo.name}</p>
                <p class="current-price">$${formattedCurrentPrice}</p>
                <p class="price-change ${changePercent >= 0 ? 'positive-change' : 'negative-change'}">${formattedPriceChange}</p>
            </div>
        `;

        coinsList.appendChild(coinCard);

    } else if (index === 7) {
        // Coin List 8: Display Everything
        coinCard.innerHTML = `
            <div class="marquee">
                <div class="coin-img-otr">
                    <img class="coin-img" class="${coinInfo.name}" src="${imagePath}" alt="${coinInfo.name}" />
                </div>
                <p class="coin-name">${coinInfo.name}</p>
                <p class="current-price">$${formattedCurrentPrice}</p>
                <p class="price-change ${changePercent >= 0 ? 'positive-change' : 'negative-change'}">${formattedPriceChange}</p>
            </div>
        `;

        coinsList.appendChild(coinCard);

    } else if (index === 8) {
        // For Swiper Slides, only create swiper-slide div
        // Coin List 9: Display Everything
        const coinCardd = document.createElement("div");
        coinCardd.classList.add("swiper-slide");

        const formattedCurrentPrice = parseFloat(coinInfo.priceUsd).toFixed(2);

        const changePercent = parseFloat(coinInfo.changePercent24Hr);
        const formattedPriceChange = isNaN(changePercent)
            ? "N/A" // Handle invalid or missing data
            : changePercent >= 0
                ? `+${changePercent.toFixed(2)}%`
                : `${changePercent.toFixed(2)}%`;

        const iconName = coinInfo.name.charAt(0).toLowerCase() + coinInfo.name.slice(1);
        const imagePath = `https://vistothemes.com/cryptocurrency/coins/${iconName}.png`;

        coinCardd.innerHTML = `
            <div class="col-inr">
                <div class="card-head">
                    <div class="coin-basic-info">
                        <div class="coin-img-otr">
                            <img class="coin-img" src="${imagePath}" alt="${coinInfo.name}" />
                        </div>
                        <div class="coin-name-info">
                            <p class="coin-name">${coinInfo.name}</p>
                            <p class="coin-symbol">${coinInfo.symbol}</p>
                        </div>
                    </div>
                    <div class="price-change-otr">
                        <p class="price-change ${changePercent >= 0 ? 'positive-change' : 'negative-change'}">${formattedPriceChange}</p>
                    </div>
                </div>
                <div class="current-price-otr">
                    <p class="current-price">$${formattedCurrentPrice}</p>
                    <p class="market-cap">Market Cap : $${formatMarketCap(parseFloat(coinInfo.marketCapUsd))}</p>
                </div>
                <div class="price-chart">
                    <canvas id="${coinInfo.id}-chart-${container}-${index}-${coinIndex}"></canvas>
                </div>
            </div>
        `;

        coinsList.appendChild(coinCardd);

    } else if (index === 9) {
        // For Swiper Slides, only create swiper-slide div
        // Coin List 9: Display Everything
        const coinCardd = document.createElement("div");
        coinCardd.classList.add("swiper-slide");

        const formattedCurrentPrice = parseFloat(coinInfo.priceUsd).toFixed(2);

        const changePercent = parseFloat(coinInfo.changePercent24Hr);
        const formattedPriceChange = isNaN(changePercent)
            ? "N/A" // Handle invalid or missing data
            : changePercent >= 0
                ? `+${changePercent.toFixed(2)}%`
                : `${changePercent.toFixed(2)}%`;

        const iconName = coinInfo.name.charAt(0).toLowerCase() + coinInfo.name.slice(1);
        const imagePath = `https://vistothemes.com/cryptocurrency/coins/${iconName}.png`;

        coinCardd.innerHTML = `
            <div class="col-inr">
                <div class="card-head">
                    <div class="coin-basic-info">
                        <div class="coin-img-otr">
                            <img class="coin-img" src="${imagePath}" alt="${coinInfo.name}" />
                        </div>
                        <div class="coin-name-info">
                            <p class="coin-name">${coinInfo.name}</p>
                            <p class="coin-symbol">${coinInfo.symbol}</p>
                        </div>
                    </div>
                    <div class="price-change-otr">
                        <p class="price-change ${changePercent >= 0 ? 'positive-change' : 'negative-change'}">${formattedPriceChange}</p>
                    </div>
                </div>
                <div class="current-price-otr">
                    <p class="current-price">$${formattedCurrentPrice}</p>
                    <p class="market-cap">Market Cap : $${formatMarketCap(parseFloat(coinInfo.marketCapUsd))}</p>
                </div>
                <div class="price-chart">
                    <canvas id="${coinInfo.id}-chart-${container}-${index}-${coinIndex}"></canvas>
                </div>
            </div>
        `;

        coinsList.appendChild(coinCardd);

    } else if (index === 10) {
        // Coin List 2: Display Everything Except Market Cap and Price Chart
        coinCard.innerHTML = `
            <div class="col-inr">
                <div class="card-head">
                    <div class="coin-basic-info">
                        <div class="coin-img-otr">
                            <img class="coin-img" src="${imagePath}" alt="${coinInfo.name}" />
                        </div>
                        <div class="coin-name-info">
                            <p class="coin-name">${coinInfo.name}</p>
                            <p class="coin-symbol">${coinInfo.symbol}</p>
                        </div>
                    </div>
                </div>
                <div class="current-price-otr">
                    <div class="current-price-inr">
                        <p class="current-price">$${formattedCurrentPrice}</p>
                        <p class="market-cap">Market Cap : $${formatMarketCap(parseFloat(coinInfo.marketCapUsd))}</p>
                    </div>
                    <div class="price-change-otr">
                        <p class="price-change ${changePercent >= 0 ? 'positive-change' : 'negative-change'}">${formattedPriceChange}</p>
                    </div>
                </div>
                <div class="price-chart">
                    <canvas id="${coinInfo.id}-chart-${container}-${index}-${coinIndex}"></canvas>
                </div>
            </div>
        `;

        coinsList.appendChild(coinCard);

    }

    

    // Create the price chart using Chart.js library
    if (index === 1 || index === 2 || index === 4 || index === 5 || index === 8 || index === 9 || index === 10) {
        // Coin List 1 and Coin List 4: Display Price Chart
        const ctx = document.getElementById(`${coinInfo.id}-chart-${container}-${index}-${coinIndex}`).getContext("2d");
        const coinLabels = priceData.map(item => moment(item.time).format('MM/DD'));
        const coinPrices = priceData.map(item => item.priceUsd);

        new Chart(ctx, {
            type: 'line',
            data: {
                labels: coinLabels,
                datasets: [{
                    label: 'Price (USD)',
                    data: coinPrices,
                    backgroundColor: (context) => {
                        const bgColor = [
                            'rgba(1, 82, 255, 0.2)',
                            'rgba(128, 169, 255, 0)',
                            'rgba(230, 109, 1, 0)',
                            
                        ];
                        if(!context.chart.chartArea) {
                            return;
                        }
                        console.log(context.chart.chartArea)
                        const { ctx, data, chartArea: {top, bottom} } = context.chart;
                        const gradientBg = ctx.createLinearGradient(0, top, 0, bottom);
                        gradientBg.addColorStop(0, bgColor[0])
                        gradientBg.addColorStop(1, bgColor[1])
                        gradientBg.addColorStop (1, bgColor [2])
                        return gradientBg;
                    },
                    borderColor: [
                        'rgba(1, 82, 255, 1)',
                    ],
                    pointBackgroundColor: [
                        'rgba(128, 169, 255, 1)',
                    ],
                    borderWidth: 2,
                    tension: 2,
                    lineTension: 0.25,
                    pointRadius: 0,
                    pointHoverRadius: 0,
                    fill: true
                }]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                legend: {
                    display: false,
                },
                scales: {
                    x: {
                        ticks: {
                            display: false,
                        },
                        grid: {
                            display: false,
                            drawTicks: false,
                        }
                    },
                    y: {
                        ticks: {
                            display: false,
                        },
                        grid: {
                            display: false,
                            drawTicks: false,
                        }
                    }
                },
                plugins: {
                    legend: {
                        display: false,
                    },
                    tooltip: {
                        mode: 'index',
                        intersect: false,
                    }
                },
            }
        });
    }
}






document.addEventListener("DOMContentLoaded", function () {
    const slider1 = new Swiper("#slider1", {
        slidesPerView: "auto",
        spaceBetween: 120,
        centeredSlides: true,
        pagination: {
            el: ".swiper-pagination",
            type: "fraction",
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });

    const slider2 = new Swiper("#slider2", {
        slidesPerView: 3,
        spaceBetween: 24,
        centeredSlides: true,
        pagination: {
            el: ".swiper-pagination",
            type: "fraction",
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });

    const slider3 = new Swiper("#slider3-CTA", {
        slidesPerView: "auto",
        centeredSlides: true,
        spaceBetween: 120,
        grabCursor: true,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
        pagination: {
            el: ".swiper-pagination",
            type: "fraction",
        },
    });
});